import { render, staticRenderFns } from "./FacilityListItem.vue?vue&type=template&id=2b1da826"
import script from "./FacilityListItem.vue?vue&type=script&lang=js"
export * from "./FacilityListItem.vue?vue&type=script&lang=js"
import style0 from "./FacilityListItem.vue?vue&type=style&index=0&id=2b1da826&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports